import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { OrderSummaryInfo } from './OrderSummaryInfo';
import { OrderSummaryTable } from './OrderSummaryTable';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import { CymbioSpinner } from '../../common/Spinner';
import { retailerOrderCloseModal } from '../../../store/actions/retailerOrders';

import styles from './OrderSummaryModal.module.scss';

export function OrderSummaryModal(props) {
  const dispatch = useDispatch();
  const {
    order: { current: order },
    modal: { open: modalOpen },
  } = useSelector((state) => state.retailerOrders);

  const onClose = () => dispatch(retailerOrderCloseModal());

  return (
    <ModalWindow open={modalOpen} onClose={onClose} size={order ? undefined : 'xlarge'}>
      {order ? (
        <>
          <OrderSummaryInfo additionalOrderStates={props.additionalOrderStates} />

          <hr />

          <OrderSummaryTable />

          <div className={styles.footer}>
            <Button text="Close" onClick={onClose} />
          </div>
        </>
      ) : (
        <CymbioSpinner />
      )}
    </ModalWindow>
  );
}

OrderSummaryModal.propTypes = {
  additionalOrderStates: PropTypes.object,
};
